import { render, staticRenderFns } from "./BridgeHistoryScrollableTable.vue?vue&type=template&id=8f36be36&scoped=true"
import script from "./BridgeHistoryScrollableTable.vue?vue&type=script&lang=ts"
export * from "./BridgeHistoryScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./BridgeHistoryScrollableTable.vue?vue&type=style&index=0&id=8f36be36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f36be36",
  null
  
)

export default component.exports